<template>
    <div class="contents-area cf">
        <div class="info">
            <h2 class="title-page">{{ localizer.get("App.Common.QuoteRequest") }}</h2>
            <div class="form">
                <div v-if="!isSuccess" id="FormCoupon">
                    <fieldset :disabled="isLoadingForm">
                        <legend class="legend">{{ localizer.get("App.Common.ContactForm_Legend") }}</legend>
                        <div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Name">{{ localizer.get("App.Common.Name") }}</label> <span class="required">*</span></span>
                                <input id="Name" name="Name" type="text" v-model.lazy="formData.name" :class="[{ 'input-validation-error': isValidationError('Name') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Name">{{ localizer.get("App.Common.Surname") }}</label> <span class="required">*</span></span>
                                <input id="Surname" name="Surname" type="text" v-model.lazy="formData.surname" :class="[{ 'input-validation-error': isValidationError('Surname') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Address">{{ localizer.get("App.Common.Address") }}</label></span>
                                <input id="Address" name="Address" type="text" v-model.lazy="formData.address" :class="[{ 'input-validation-error': isValidationError('Address') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="City">{{ localizer.get("App.Common.City") }}</label></span>
                                <input id="City" name="City" type="text" v-model.lazy="formData.city" :class="[{ 'input-validation-error': isValidationError('City') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Province">{{ localizer.get("App.Common.Province") }}</label></span>
                                <input id="Province" name="Province" type="text" v-model.lazy="formData.province" :class="[{ 'input-validation-error': isValidationError('Province') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Phone">{{ localizer.get("App.Common.Phone") }}</label> <span class="required">*</span></span>
                                <input id="Phone" name="Phone" type="tel" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Fax">{{ localizer.get("App.Common.Fax") }}</label></span>
                                <input id="Fax" name="Fax" type="text" v-model.lazy="formData.fax" :class="[{ 'input-validation-error': isValidationError('Fax') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="Email">{{ localizer.get("App.Common.Email") }}</label> <span class="required">*</span></span>
                                <input id="Email" name="Email" type="email" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'fl-l textbox']" />
                            </div>
                            <div class="form-row cf">
                                <span class="fl-l label"><label for="CouponMessage">{{ localizer.get("App.Common.Message") }}</label></span>
                                <textarea class="fl-l textarea" cols="20" id="CouponMessage" name="CouponMessage" rows="5" v-model.lazy="formData.couponMessage"></textarea>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset :disabled="isLoadingForm">
                        <div class="form-row cf">
                            <label :class="[{ 'input-validation-error': isValidationError('TermsAgreement') }, 'fl-l radiobuttonlist']">
                                <input type="checkbox" name="TermsAgreement" id="TermsAgreement" v-model.lazy="formData.termsAgreement">Ho letto l’<a :href="routes.DataSecurity_PrivacyPolicy" target="_blank">informativa privacy</a>
                            </label>
                        </div>
                    </fieldset>
                    <div v-if="validationErrors.length !== 0" class="row validation-summary-errors">
                        <ul>
                            <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                        </ul>
                    </div>
                    <div class="cf">
                        <div class="fl-l update-button">
                            <button :disabled="isLoadingForm" @click="submitForm()" class="button disable-on-submit">{{ localizer.get("App.Common.Send") }}</button>
                        </div>
                    </div>
                </div>
                <div v-else class="success-box">
                    <div class="title-confirm">{{ localizer.get("App.Common.CouponSentConfirm_Title") }}</div>
                    {{ localizer.get("App.Common.CouponSentConfirm_Abstract") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    contentTitle: string,
    contentText: string
}>();

const localizer = Localizer;
const formData = ref<any>({ termsAgreement: false });
const validationErrors = ref<any[]>([]);
const isLoadingForm = ref(false);
const isSuccess = ref(false);

const routes = (window as any).App.routes;

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Contact_CouponPost, formData.value);
        GTagHelper.sendEvent("form_submit", "inforequest_form", "success");
        isSuccess.value = true;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>